import React from "react";
import styled from "styled-components";
import Progress from "antd/es/progress";
import Statistics from "components/Statistics";

const CenterWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 0 24px 0;
`;

const WorkingShiftsChart = ({ data = [], totShifts = 0 }) => {
  const withPeople = Number(
    (data.find((d) => d.type === "working shifts with people") || {}).value || 0
  );
  const totalShifts = Number(totShifts || 0);
  const percent = totalShifts > 0 ? Math.round((withPeople * 1000) / totalShifts) / 10 : 0;

  return (
    <CenterWrapper>
      <Progress
        type="circle"
        percent={percent}
        strokeColor="#000912"
        trailColor="#E4E8ED"
        strokeWidth={12}
        strokeLinecap="square"
        width={220}
        format={() => (
          <Statistics
            title={"Shifts Worked"}
            value={`${withPeople}/${totalShifts}`}
            titleAlign={["center", "bottom"]}
            valueStyle={{ fontSize: "30px", fontWeight: 600, lineHeight: "38px" }}
          />
        )}
      />
    </CenterWrapper>
  );
};

export default WorkingShiftsChart;
